import { Layout } from 'react-admin';

export default Layout;